export default __webpack_public_path__ + "static/elliot-45e4494b0b6e02ccd3d4f71006ba4fab.png";